import { useGetPage } from "@circle-react/components/Site/Pages/hooks/useGetPage";
import type { Space } from "@circle-react/types";
import { defaultBlocks } from "@circle-react-shared/BuilderUI/DefaultBlocks";
import { createBlockRendererMapping } from "@circle-react-shared/BuilderUI/Helpers/blockMappings";
import { AttachmentProvider } from "@circle-react-shared/BuilderUI/Media/AttachmentContext";
import { BlockRenderer } from "@circle-react-shared/BuilderUI/Renderer/BlockRenderer";
import { UserThemeManager } from "@circle-react-shared/BuilderUI/ThemeManager/UserThemeManager";
import "@circle-react-shared/BuilderUI/styles/builder-ui.css";
import { Loader } from "@circle-react-uikit/Loader";

export interface SitePageLockscreenProps {
  space: Space;
}

export const SitePageLockscreen = ({ space }: SitePageLockscreenProps) => {
  const { isLoading, data: page } = useGetPage({
    id: space.lockscreen_site_page_id,
  });

  if (isLoading || !page) {
    return <Loader center />;
  }

  const content = page.blocks?.content;
  const inlineAttachments = page.blocks?.inline_attachments;

  if (!content || page.unauthorized_reason) {
    return null;
  }

  const components = createBlockRendererMapping(defaultBlocks);

  return (
    <div className="bg-primary text-dark h-full">
      <UserThemeManager
        theme={page.theme.css_variables || {}}
        appearance={page.appearance || page.theme.appearance || "light"}
      >
        <AttachmentProvider attachments={inlineAttachments}>
          <BlockRenderer block={content} components={components} />
        </AttachmentProvider>
      </UserThemeManager>
    </div>
  );
};
